<script>
export default {
    props: {
        value: Array,
        stores: Array,
        product_slug: String,
        v: Object,
        submitted: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
        }
    },
    components: {        
    },
    methods: {
        addRow(){
            this.value.push({
                id: '',
                slug: null,
            });
        },
        deleteRow(key){
            this.value.splice(key, 1);
        },
    },
};
</script>

<template>
    <table class="table table-bordered table-sticky-header">
        <thead>
            <tr>
                <th scope="col">Tienda</th>
                <th scope="col">Slug</th>
                <th scope="col">Orden</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(store, i) in value" :key="i" :set="vstore = v.product.stores.$each[i]" class="">
                <td>
                    <div class="form-group">
                        <select v-model="store.id" class="form-control"
                            :class="{ 'is-invalid': vstore.id.$error && submitted }">
                            <option value="">Select</option>
                            <option v-for="option in stores" v-bind:value="option.id" :key="option.id">
                                {{ option.name }}
                            </option>
                        </select>                                            
                    </div>
                </td>
                <td>
                    <div class="form-group">
                        <input 
                            type="text"
                            v-model="store.slug"
                            class="form-control"
                            :class="{ 'is-invalid': vstore.slug.$error }"
                            :placeholder="product_slug ?? 'Slug'"
                        />
                    </div>
                </td>
                <td>
                    <div class="form-group">
                        <input 
                            type="number"
                            v-model="store.menu_order"
                            class="form-control"
                            :class="{ 'is-invalid': vstore.menu_order.$error }"
                            placeholder="Orden"
                        />
                    </div>
                </td>
                <td class="text-center">
                    <a
                        href="javascript:void(0);"
                        class="text-danger"
                        v-b-tooltip.hover
                        title="Eliminar"
                        @click="deleteRow(i)"
                        v-if="!store?.is_update"
                    >
                        <i class="mdi mdi-trash-can font-size-18"></i>
                    </a>
                </td>
            </tr>
        </tbody>
        <tfoot>
            <tr>
                <td colspan="4" class="text-right">
                    <a
                        href="javascript:void(0);"
                        class="text-success"
                        @click="addRow()"
                    >
                        <i class="mdi mdi-plus-circle font-size-18"></i> Agregar tienda
                    </a>
                </td>
            </tr>
        </tfoot>
    </table>
</template>